import React from "react";
import { appStyles } from "../../../utils/appStyle";
import Block from "../../../component/block";
import mixpanel from "mixpanel-browser";
import { logContentBlockPressEvent } from "../../../utils/events";
import { useAppContext } from './../../../util'

const AppDownload = ({
  contentBlockId,
  ios,
  android,
  highlight,
  color,
  index,
}) => {

  const { userId, pageId } = useAppContext()

  // Function to detect the device type
  const getDeviceType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return "android";
    } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
      return "ios";
    }

    return "unknown";
  };

  const STYLES = appStyles(color, highlight);

  const deviceType = getDeviceType();

  const handleSocket = () => {
    logContentBlockPressEvent(contentBlockId)
    mixpanel.track("Web Link Clicked", {
      Button_type: "applink",
      distinct_id: userId,
      stack_id: pageId,
    });
  };
  return (
    <div
      onClick={handleSocket}
      key={index}
      style={{
        marginTop: "8px",
        borderRadius: STYLES.borderRadius,
        border: STYLES.border,
        background: STYLES.background,
      }}
    >
      <a
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: STYLES.Color,
          textDecoration: "none",
          padding: "15px",
        }}
        target="_blank"
        href={deviceType === "ios" ? ios : android} rel="noreferrer"
      >
        {["android", "ios"].includes(deviceType) ? (
          <Block
            icon={
              deviceType === "ios"
                ? "fa-brands fa-apple"
                : "fa-brands fa-google-play"
            }
            content={
              deviceType === "ios"
                ? "Download on the App Store"
                : "Download on Play Store"
            }
            rightIcon="fa-sharp fa-solid fa-arrow-down-to-line"
          />
        ) : (
          <Block
            icon={
              index === 0 ? "fa-brands fa-apple" : "fa-brands fa-google-play"
            }
            content={
              index === 0
                ? "Download on the App Store"
                : "Download on Play Store"
            }
            rightIcon="fa-sharp fa-solid fa-arrow-down-to-line"
          />
        )}
      </a>
    </div>
  );
};

export default AppDownload;
